import { useQuery } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'emailExecAssistant/digests/latest';

export const useLatestEmailExecDigestQuery = () => {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [BASE_QUERY_KEY],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IEmailExecDigest | null>('emailExecAssistant/digests/latest', 'GET'),
	});
};

export const invalidateLatestEmailExecDigest = () => reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
